import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const createWorkflowAutomationEvent = gql`
  mutation CreateWorkflowAutomationEventMutation($input: CreateWorkflowAutomationEvent!) {
    createWorkflowAutomationEvent(input: $input)
  }
`;

export const createAutomation = gql`
  mutation CreateAutomation($input: CreateAutomation!) {
    createAutomation(input: $input) {
      ...Automation
    }
  }

  ${Fragments.automation.Automation}
`;

export const updateAutomation = gql`
  mutation UpdateAutomation($input: UpdateAutomation!) {
    updateAutomation(input: $input) {
      ...Automation
    }
  }

  ${Fragments.automation.Automation}
`;

export const deleteAutomation = gql`
  mutation DeleteAutomation($id: UUID!) {
    deleteAutomation(id: $id)
  }
`;
